<template>
	<div class="diagens-header-bar">
		<ContentPad>
			<div class="diagens-header-bar__inner">
				<div class="diagens-header-bar__logo">
					<img :src="diagensLogo" alt="logo" class="diagens-header-bar__logo-img" />
				</div>

				<div v-if="showLanguageBtn" class="diagens-header-bar__lang">
					<template v-for="(lang, index) in sortedLangs">
						<span v-if="index > 0" :key="`sep-${lang.key}`" class="diagens-header-bar__lang-sep">/</span>
						<span
							:key="lang.key"
							class="diagens-header-bar__lang-item"
							:class="{ 'diagens-header-bar__lang-item--active': lang.key === currentLang }"
							@click="handleLangChange(lang.key)"
						>
							{{ lang.label }}
						</span>
					</template>
				</div>
			</div>
		</ContentPad>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import i18n, { EN, ZH, ZH_HK } from '@/locales';
import ContentPad from '@rebuild/materials/shared/common/ContentPad.vue';
import { useCommonData } from '@/hooks';
import { useLanguageSwitch } from '@rebuild/materials/shared/floating/hooks/useLanguageSwitch';
import diagensLogo from './diagens_logo.png';

const { showLanguageBtn, enabledLangList, changeLocaleLang } = useLanguageSwitch();
const currentLang = computed(() => i18n.locale);

const langLabelMap = {
	[ZH]: '中',
	[ZH_HK]: '繁',
	[EN]: 'En'
};
const sortRule = [ZH, EN, ZH_HK];
const sortedLangs = computed(() => {
	return [...enabledLangList.value]
		.sort((a, b) => sortRule.indexOf(a) - sortRule.indexOf(b))
		.map(key => ({ key, label: langLabelMap[key] || key }));
});

const { viewInIframe } = useCommonData();
const handleLangChange = key => {
	if (viewInIframe.value) return;
	if (key === currentLang.value) return;
	changeLocaleLang(key);
};
</script>

<style lang="less" scoped>
@diagens-header-bar-height: 56px;

.diagens-header-bar {
	height: @diagens-header-bar-height;
	background: #ffffff;

	&__inner {
		height: @diagens-header-bar-height;
		display: flex;
		align-items: center;
	}

	&__logo {
		flex: none;
		height: 28px;
		display: flex;
		align-items: center;
	}

	&__logo-img {
		height: 100%;
		object-fit: contain;
	}

	&__lang {
		margin-left: auto;
		display: flex;
		align-items: center;
		gap: 16px;
	}

	&__lang-sep {
		color: #c9cdd4;
		font-size: 13px;
		font-weight: 400;
		line-height: 16px;
	}

	&__lang-item {
		color: #4e5969;
		font-size: 13px;
		font-weight: 400;
		line-height: 16px;
		cursor: pointer;
		transition: color 0.2s;

		&--active {
			color: var(--theme-color);
			cursor: default;
		}

		&:not(&--active):hover {
			color: var(--theme-color);
		}
	}
}
</style>
